import { render, staticRenderFns } from "./OfferAcceptedPage.vue?vue&type=template&id=67f02cfc&"
import script from "./OfferAcceptedPage.vue?vue&type=script&lang=js&"
export * from "./OfferAcceptedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports